import { LocalDate } from "@js-joda/core";
import React from "react";
import { AddressComponents, PatientGender } from "../../../messages";
import { TaskDayTimeParams } from "../../../messages/PatientTasks";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppList } from "../../Generic/AppList";
import { IsDefined } from "../../Generic/IsDefined";
import PatientInformationAppListItem from "../../PatientInformationAppListItem";
import AvailableTaskAddress from "./AvailableTaskAddress";
import AvailableTaskDurationMinutes from "./AvailableTaskDurationMinutes";
import AvailableTaskTimeFrame from "./AvailableTaskTimeFrame";

interface Props {
  dayTimeParams: TaskDayTimeParams;
  startDate: LocalDate;
  dueDate: LocalDate;
  durationMinutes: number | null;
  patientAddress: string | null;
  patientAddressComponents: AddressComponents | null;
  patientAge: number | null;
  patientGender: PatientGender | null;
  patientInitials: string;
  onClickLocation: () => void;
  onClickPatientSchedule: () => void;
}

const OnboardingTaskDetails = (props: Props) => {
  return (
    <div className="AvailableTaskDetails">
      <AppCard>
        <AppCardHeader>
          <AppCardTitle>{translate(STRINGS.VISIT_DETAILS)}</AppCardTitle>
        </AppCardHeader>
        <AppCardContent>
          <AppList>
            <AvailableTaskTimeFrame
              dayTimeParams={props.dayTimeParams}
              startDate={props.startDate}
              dueDate={props.dueDate}
            />

            <IsDefined value={props.durationMinutes}>
              {(durationMinutes) => (
                <AvailableTaskDurationMinutes durationMinutes={durationMinutes} />
              )}
            </IsDefined>

            <AvailableTaskAddress
              addressString={props.patientAddress}
              addressComponents={props.patientAddressComponents}
              addressInstructions={null}
              onClickLocation={props.onClickLocation}
            />

            <PatientInformationAppListItem
              patientAge={props.patientAge}
              patientGender={props.patientGender}
              patientName={props.patientInitials}
              hasAccessToPatient={false}
            />
          </AppList>
        </AppCardContent>
      </AppCard>
    </div>
  );
};

export default OnboardingTaskDetails;
